// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2CZWE","productName":"Table_productName__NY9u-"};